// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + {"318":"capture","427":"connect","443":"about"}[chunkId] + "." + {"318":"13f0d10d","427":"29375499","443":"451b781f"}[chunkId] + ".css";
};